/* 24parts — Dark Sides design system JS (rh-*) */
(function () {
  if (window.__rhLoaded) return;
  window.__rhLoaded = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (designMode) document.documentElement.classList.add('rh-design-mode');

  /* ---------- helpers ---------- */
  /* Pick ONE rendition: phones / slow links get <=720p, desktop gets the biggest. (Shopify lists 1080p first,
     and the browser would otherwise download that one — ~5 MB hero on a phone.) */
  var conn = navigator.connection || {};
  var smallScreen = window.matchMedia('(max-width: 749px)').matches || /(^|-)[23]g$/.test(conn.effectiveType || '');
  function loadVideo(v) {
    if (v.dataset.rhLoaded) return;
    v.dataset.rhLoaded = '1';
    var list = [].slice.call(v.querySelectorAll('source[data-src]'));
    var mp4 = list.filter(function (s) { return /mp4/.test(s.type); });
    var pool = (mp4.length ? mp4 : list).sort(function (a, b) { return (+a.dataset.h || 0) - (+b.dataset.h || 0); });
    var pick = pool[pool.length - 1];
    if (smallScreen && pool.length > 1) {
      var ok = pool.filter(function (s) { return (+s.dataset.h || 0) <= 720; });
      pick = ok.length ? ok[ok.length - 1] : pool[0];
    }
    if (pick) { v.src = pick.dataset.src; list.forEach(function (s) { s.remove(); }); }
    v.load();
  }
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  /* hero video waits for the page to finish loading, so the poster image (LCP) gets the bandwidth first */
  var pageLoaded = document.readyState === 'complete';
  var waiting = [];
  if (!pageLoaded) window.addEventListener('load', function () {
    setTimeout(function () { pageLoaded = true; waiting.splice(0).forEach(function (fn) { fn(); }); }, 400);
  });
  function play(v) {
    if (saveData) return;
    if (smallScreen && v.hasAttribute('data-rh-desktop-only')) return;
    if (!pageLoaded && v.closest('.rh-hero')) { waiting.push(function () { play(v); }); return; }
    loadVideo(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    var holder = v.closest('.rh-reel, [data-rh-hover]');
    if (holder) holder.classList.add('is-playing');
  }
  function pause(v) {
    if (!v.paused) v.pause();
    var holder = v.closest('.rh-reel, [data-rh-hover]');
    if (holder) holder.classList.remove('is-playing');
  }

  /* ---------- split text into letters ---------- */
  function split(root) {
    root.querySelectorAll('[data-rh-split]:not([data-rh-split-done])').forEach(function (el) {
      el.setAttribute('data-rh-split-done', '');
      var text = el.textContent.trim();
      if (!text) return;
      el.setAttribute('aria-label', text);
      el.textContent = '';
      var i = 0;
      text.split(/(\s+)/).forEach(function (word) {
        if (/^\s+$/.test(word)) { el.appendChild(document.createTextNode(' ')); return; }
        var w = document.createElement('span');
        w.style.display = 'inline-block'; w.style.whiteSpace = 'nowrap';
        w.setAttribute('aria-hidden', 'true');
        Array.from(word).forEach(function (ch) {
          var c = document.createElement('span');
          c.className = 'rh-ch'; c.textContent = ch;
          c.style.transitionDelay = Math.min(i++ * 0.03, 0.9) + 's';
          w.appendChild(c);
        });
        el.appendChild(w);
      });
    });
  }

  /* ---------- reveal ---------- */
  var revealIO = ('IntersectionObserver' in window) && !reduce ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }) : null;

  /* ---------- videos that autoplay while visible (hero, feature, drop) ---------- */
  var inviewIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) play(e.target); else pause(e.target); });
  }, { rootMargin: '200px 0px 200px 0px', threshold: 0.01 }) : null;

  /* ---------- reels: hover on desktop, centre-of-screen on phone ---------- */
  var centreIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target.querySelector('video');
      if (e.isIntersecting) { e.target.classList.add('is-center'); if (v) play(v); }
      else { e.target.classList.remove('is-center'); if (v) pause(v); }
    });
  }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 }) : null;

  /* ---------- marquees: only animate while on screen ---------- */
  var marqueeIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
  }, { rootMargin: '80px 0px' }) : null;

  /* ---------- colour ramp (sport bridge) ---------- */
  var ramps = [];
  function updateRamps() {
    var vh = window.innerHeight;
    ramps.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var travel = Math.max(r.height - vh, 1);
      var p = Math.min(1, Math.max(0, (-r.top + vh * 0.15) / travel));
      el.style.setProperty('--p', p.toFixed(3));
    });
  }

  /* ---------- hero parallax (desktop only) ---------- */
  var parallax = [];
  function updateParallax() {
    var y = window.scrollY;
    parallax.forEach(function (el) {
      if (y < window.innerHeight * 1.2) el.style.transform = 'translate3d(0,' + (y * 0.12).toFixed(1) + 'px,0) scale(1.08)';
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { if (ramps.length) updateRamps(); if (parallax.length) updateParallax(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', updateRamps, { passive: true });

  /* ---------- init a root (page or re-rendered section) ---------- */
  function init(root) {
    split(root);
    if (marqueeIO) root.querySelectorAll('.rh-marquee').forEach(function (m) { marqueeIO.observe(m); });

    root.querySelectorAll('[data-rh-reveal],[data-rh-split],.rh-vine').forEach(function (t) {
      if (revealIO && !designMode) revealIO.observe(t); else t.classList.add('is-in');
    });

    root.querySelectorAll('video[data-rh-inview]').forEach(function (v) {
      if (reduce) { loadVideo(v); return; }
      if (inviewIO) inviewIO.observe(v); else play(v);
    });

    root.querySelectorAll('[data-rh-hover]').forEach(function (card) {
      var v = card.querySelector('video');
      if (canHover) {
        if (v) {
          card.addEventListener('mouseenter', function () { play(v); });
          card.addEventListener('mouseleave', function () { pause(v); });
          card.addEventListener('focusin', function () { play(v); });
          card.addEventListener('focusout', function () { pause(v); });
        }
      } else if (centreIO) {
        centreIO.observe(card);
      }
    });

    /* archive cards get colour when centred on phones */
    if (!canHover && centreIO) root.querySelectorAll('.rh-grid--archive .rh-card').forEach(function (c) { centreIO.observe(c); });

    /* finish toggle (Chrome / Holo) */
    root.querySelectorAll('[data-rh-finish]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.rh-design');
        var key = btn.getAttribute('data-rh-finish');
        card.querySelectorAll('[data-rh-finish]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        card.querySelectorAll('[data-rh-finish-pane]').forEach(function (p) {
          var on = p.getAttribute('data-rh-finish-pane') === key;
          p.classList.toggle('is-on', on);
          if (p.tagName === 'VIDEO') { on ? play(p) : pause(p); }
        });
        if (btn.dataset.href) card.querySelectorAll('[data-rh-finish-link]').forEach(function (l) { l.href = btn.dataset.href; });
      });
    });

    /* swipe rail progress bar */
    root.querySelectorAll('[data-rh-rail]').forEach(function (rail) {
      var bar = rail.parentElement.querySelector('.rh-rail-hint__bar i');
      if (!bar) return;
      var upd = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var vis = rail.clientWidth / Math.max(rail.scrollWidth, 1);
        bar.style.width = (vis * 100).toFixed(1) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0).toFixed(1) + '%)';
      };
      rail.addEventListener('scroll', upd, { passive: true });
      upd();
    });

    root.querySelectorAll('[data-rh-ramp]').forEach(function (el) { if (ramps.indexOf(el) < 0) ramps.push(el); });
    if (!reduce && canHover) root.querySelectorAll('[data-rh-parallax]').forEach(function (el) { if (parallax.indexOf(el) < 0) parallax.push(el); });
    updateRamps();
    magnet(root);
  }


  /* ---------- magnetic buttons (desktop pointer only; no React-style state, rAF-free: writes CSS vars) ---------- */
  function magnet(root) {
    if (reduce || !canHover) return;
    root.querySelectorAll('.rh-btn:not([data-rh-mag])').forEach(function (b) {
      if (b.closest('.rh--sport')) return;
      b.setAttribute('data-rh-mag', '');
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left - r.width / 2) * 0.12).toFixed(1) + 'px');
        b.style.setProperty('--my', ((e.clientY - r.top - r.height / 2) * 0.2).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.removeProperty('--mx'); b.style.removeProperty('--my'); });
    });
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    el.querySelectorAll && el.querySelectorAll('[data-rh-reveal],[data-rh-split]').forEach(function (t) { t.classList.add('is-in'); });
    if (el.scrollIntoView && el.closest('[data-rh-rail]')) el.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  });
})();
